// // src/pages/events/EventList.js
// import DeleteIcon from '@mui/icons-material/Delete';
// import EditIcon from '@mui/icons-material/Edit';
// import {
//   Box,
//   Button,
//   IconButton,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
// } from '@mui/material';
// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import AdminHeader from '../../components/AdminHeader';
// import LayoutContainer from '../../components/LayoutContainer';
// import itemDeliveryService from '../../services/itemDeliveryService';
// import { get, groupBy, map, partition, split, startsWith } from 'lodash';
// import { ImageModal } from '../supervisor/Supervisor';

// const StaionReport = () => {
//   const [itemDeliveries, setItemDeliveries] = useState([]);
//   const navigate = useNavigate();
//   const [openModal, setOpenModal] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);

//   const fetchItemDeliveries = async () => {
//     const response = await itemDeliveryService.getItemDeliveries();
//     setItemDeliveries(groupBy(response?.data, 'department_name'));
//   };

//   useEffect(() => {
//     fetchItemDeliveries();
//   }, []);

//   // Function to close the modal
//   const handleCloseModal = () => {
//     setOpenModal(false);
//     setSelectedImage(null);
//   };

//   return (
//     <LayoutContainer>
//       <AdminHeader title='Station Report' />
//       <div className='page-content-wrapper scrollable'>
//         {/* <Table
//           style={{
//             width: '100%',
//             borderCollapse: 'collapse',
//             fontFamily: 'Arial, sans-serif',
//             marginTop: '20px',
//           }}
//         >
//           <TableHead
//             style={{
//               backgroundColor: '#2F3542',
//               fontWeight: 'bold',
//             }}
//           >
//             <TableRow>
//             <TableCell
//                 style={{
//                   padding: '12px 15px',
//                   textAlign: 'left',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                   color: '#fff',
//                 }}
//               >
//                 Station
//               </TableCell>
//               <TableCell
//                 style={{
//                   padding: '12px 15px',
//                   color: '#fff',
//                   textAlign: 'left',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                 }}
//               >
//                 Item
//               </TableCell>
//               <TableCell
//                 style={{
//                   padding: '12px 15px',
//                   textAlign: 'left',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                   color: '#fff',
//                 }}
//               >
//                 Allocated Qty
//               </TableCell>
//               <TableCell
//                 style={{
//                   padding: '12px 15px',
//                   textAlign: 'left',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                   color: '#fff',
//                 }}
//               >
//                 Delivered Qty
//               </TableCell>
//               <TableCell
//                 style={{
//                   padding: '12px 15px',
//                   textAlign: 'left',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                   color: '#fff',
//                 }}
//               >
//                 Picked Qty
//               </TableCell>
//               <TableCell
//                 style={{
//                   padding: '12px 15px',
//                   textAlign: 'left',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                   color: '#fff',
//                 }}
//               >
//                 Status
//               </TableCell>
//               <TableCell
//                 style={{
//                   padding: '12px 15px',
//                   textAlign: 'left',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                   color: '#fff',
//                 }}
//               >
//                 Photo
//               </TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {itemDeliveries?.map((item) => {
//               const allocatedQty = parseInt(get(item, 'allocated_qty', 0));
//               const deliveredQty = parseInt(get(item, 'delivered_qty', 0));
//               const pickedQty = parseInt(get(item, 'picked_qty', 0));
//               let status;

//               if (allocatedQty < deliveredQty) {
//                 status = `Exceeded ${pickedQty ? ' & Pickup' : ''}`;
//               } else if (allocatedQty === deliveredQty) {
//                 status = 'Delivered';
//               } else if (allocatedQty > deliveredQty && deliveredQty !== 0) {
//                 status = `Partially Delivered ${pickedQty ? ' & Pickup' : ''}`;
//               } else {
//                 status = 'Not Delivered';
//               }

//               return (
//                 <TableRow
//                   key={item?.id}
//                   style={{
//                     transition: 'background-color 0.3s',
//                     cursor: 'pointer',
//                   }}
//                   onMouseOver={(e) =>
//                     (e.currentTarget.style.backgroundColor = '#f2f2f2')
//                   }
//                   onMouseOut={(e) =>
//                     (e.currentTarget.style.backgroundColor = '')
//                   }
//                 >
//                   <TableCell
//                     style={{
//                       padding: '12px 15px',
//                       textAlign: 'left',
//                       border: '1px solid #ddd',
//                     }}
//                   >
//                     {item?.item_name}
//                   </TableCell>
//                   <TableCell
//                     style={{
//                       padding: '12px 15px',
//                       textAlign: 'left',
//                       border: '1px solid #ddd',
//                     }}
//                   >
//                     {item?.department_name}
//                   </TableCell>
//                   <TableCell
//                     style={{
//                       padding: '12px 15px',
//                       textAlign: 'left',
//                       border: '1px solid #ddd',
//                     }}
//                   >
//                     {item?.allocated_qty}
//                   </TableCell>
//                   <TableCell
//                     style={{
//                       padding: '12px 15px',
//                       textAlign: 'left',
//                       border: '1px solid #ddd',
//                     }}
//                   >
//                     {item?.delivered_qty}
//                   </TableCell>
//                   <TableCell
//                     style={{
//                       padding: '12px 15px',
//                       textAlign: 'left',
//                       border: '1px solid #ddd',
//                     }}
//                   >
//                     {item?.picked_qty}
//                   </TableCell>
//                   <TableCell
//                     style={{
//                       padding: '12px 15px',
//                       textAlign: 'left',
//                       border: '1px solid #ddd',
//                     }}
//                   >
//                     {status}
//                   </TableCell>
//                   <TableCell
//                     style={{
//                       padding: '12px 15px',
//                       textAlign: 'center',
//                       border: '1px solid #ddd',
//                     }}
//                   >
//                     <img
//                       src={`${process.env.REACT_APP_IMAGE_URL}/images/${item?.photo}`}
//                       height={45}
//                       width={50}
//                       style={{
//                         borderRadius: '50%',
//                         border: '2px solid #ddd',
//                         padding: '2px',
//                       }}
//                       alt={item?.item_name}
//                     />
//                   </TableCell>
//                 </TableRow>
//               );
//             })}
//           </TableBody>
//         </Table> */}

//         <Table
//           style={{
//             width: '100%',
//             borderCollapse: 'collapse',
//             fontFamily: 'Arial, sans-serif',
//             marginTop: '20px',
//           }}
//         >
//           <TableHead style={{ backgroundColor: '#2F3542', fontWeight: 'bold' }}>
//             <TableRow>
//               <TableCell
//                 style={{
//                   padding: '12px 15px',
//                   color: '#fff',
//                   textAlign: 'left',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                 }}
//               >
//                 Item
//               </TableCell>
//               <TableCell
//                 style={{
//                   padding: '12px 15px',
//                   textAlign: 'left',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                   color: '#fff',
//                 }}
//               >
//                 Allocated Qty
//               </TableCell>
//               <TableCell
//                 style={{
//                   padding: '12px 15px',
//                   textAlign: 'left',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                   color: '#fff',
//                 }}
//               >
//                 Delivered Qty
//               </TableCell>
//               <TableCell
//                 style={{
//                   padding: '12px 15px',
//                   textAlign: 'left',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                   color: '#fff',
//                 }}
//               >
//                 Picked Qty
//               </TableCell>
//               <TableCell
//                 style={{
//                   padding: '12px 15px',
//                   textAlign: 'left',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                   color: '#fff',
//                 }}
//               >
//                 Status
//               </TableCell>
//               <TableCell
//                 style={{
//                   padding: '12px 15px',
//                   textAlign: 'left',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                   color: '#fff',
//                 }}
//               >
//                 Delivery Photo
//               </TableCell>
//               <TableCell
//                 style={{
//                   padding: '12px 15px',
//                   textAlign: 'left',
//                   border: '1px solid #ddd',
//                   fontSize: '16px',
//                   color: '#fff',
//                 }}
//               >
//                 Pickup Photo
//               </TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {Object.entries(itemDeliveries)?.map(([station, items]) => (
//               <>
//                 <TableRow
//                   key={station}
//                   style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}
//                 >
//                   <TableCell
//                     colSpan={7}
//                     style={{
//                       textAlign: 'left',
//                       padding: '12px 15px',
//                       border: '1px solid #ddd',
//                       fontWeight: 600,
//                     }}
//                   >
//                     {station}
//                   </TableCell>
//                 </TableRow>
//                 {items.map((item) => {
//                   const [deliveredPhoto, pickupPhoto] = item?.photo
//                     ? partition(item?.photo?.split(', '), (item) =>
//                         startsWith(item, 'Delivered')
//                       )
//                     : '-';

//                   const allocatedQty = parseInt(get(item, 'allocated_qty', 0));
//                   const deliveredQty = parseInt(get(item, 'delivered_qty', 0));
//                   const pickedQty = parseInt(get(item, 'picked_qty', 0));
//                   let status;

//                   if (allocatedQty < deliveredQty) {
//                     status = `Exceeded ${pickedQty ? ' & Pickup' : ''}`;
//                   } else if (
//                     allocatedQty > 0 &&
//                     allocatedQty === deliveredQty
//                   ) {
//                     status = 'Delivered';
//                   } else if (
//                     allocatedQty > deliveredQty &&
//                     deliveredQty !== 0
//                   ) {
//                     status = `Partially Delivered ${
//                       pickedQty ? ' & Pickup' : ''
//                     }`;
//                   } else {
//                     status = 'Not Delivered';
//                   }

//                   return (
//                     <TableRow
//                       key={item?.id}
//                       style={{
//                         transition: 'background-color 0.3s',
//                         cursor: 'pointer',
//                       }}
//                       onMouseOver={(e) =>
//                         (e.currentTarget.style.backgroundColor = '#f2f2f2')
//                       }
//                       onMouseOut={(e) =>
//                         (e.currentTarget.style.backgroundColor = '')
//                       }
//                     >
//                       <TableCell
//                         style={{
//                           padding: '12px 15px',
//                           textAlign: 'left',
//                           border: '1px solid #ddd',
//                         }}
//                       >
//                         {item?.item_name}
//                       </TableCell>
//                       {/* <TableCell
//                         style={{
//                           padding: '12px 15px',
//                           textAlign: 'left',
//                           border: '1px solid #ddd',
//                         }}
//                       >
//                         {item?.department_name}
//                       </TableCell> */}
//                       <TableCell
//                         style={{
//                           padding: '12px 15px',
//                           textAlign: 'left',
//                           border: '1px solid #ddd',
//                         }}
//                       >
//                         {item?.allocated_qty}
//                       </TableCell>
//                       <TableCell
//                         style={{
//                           padding: '12px 15px',
//                           textAlign: 'left',
//                           border: '1px solid #ddd',
//                         }}
//                       >
//                         {item?.delivered_qty}
//                       </TableCell>
//                       <TableCell
//                         style={{
//                           padding: '12px 15px',
//                           textAlign: 'left',
//                           border: '1px solid #ddd',
//                         }}
//                       >
//                         {item?.picked_qty}
//                       </TableCell>
//                       <TableCell
//                         style={{
//                           padding: '12px 15px',
//                           textAlign: 'left',
//                           border: '1px solid #ddd',
//                           color: 'white',
//                           backgroundColor:
//                             status === 'Delivered'
//                               ? '#15be15'
//                               : status === 'Exceeded'
//                               ? '#ff0101'
//                               : status === 'Exceeded  & Pickup'
//                               ? '#ff0101'
//                               : status === 'Partially Delivered '
//                               ? '#1C90FF'
//                               : status === 'Partially Delivered  & Pickup'
//                               ? '#1C90FF'
//                               : status === 'Not Delivered'
//                               ? 'orange'
//                               : 'Yellow',
//                         }}
//                       >
//                         {status}
//                       </TableCell>
//                       <TableCell
//                         style={{
//                           padding: '12px 15px',
//                           textAlign: 'center',
//                           border: '1px solid #ddd',
//                         }}
//                       >
//                         {deliveredPhoto ? (
//                           <img
//                             src={`${process.env.REACT_APP_IMAGE_URL}/images/${deliveredPhoto}`}
//                             height={45}
//                             width={50}
//                             style={{
//                               borderRadius: '10%',
//                               border: '2px solid #ddd',
//                               padding: '2px',
//                               cursor: 'pointer', // Make it look clickable
//                             }}
//                             alt='Item'
//                             onClick={() => {
//                               setOpenModal(true);
//                               setSelectedImage(deliveredPhoto);
//                             }} // Open modal with clicked image
//                           />
//                         ) : (
//                           '-'
//                         )}
//                       </TableCell>
//                       <TableCell
//                         style={{
//                           padding: '12px 15px',
//                           textAlign: 'center',
//                           border: '1px solid #ddd',
//                         }}
//                       >
//                         {pickupPhoto ? (
//                           <img
//                             src={`${process.env.REACT_APP_IMAGE_URL}/images/${pickupPhoto}`}
//                             height={45}
//                             width={50}
//                             style={{
//                               borderRadius: '10%',
//                               border: '2px solid #ddd',
//                               padding: '2px',
//                               cursor: 'pointer',
//                             }}
//                             alt='Item'
//                             onClick={() => {
//                               setOpenModal(true);
//                               setSelectedImage(pickupPhoto);
//                             }}
//                           />
//                         ) : (
//                           '-'
//                         )}
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })}
//               </>
//             ))}
//           </TableBody>
//         </Table>
//       </div>
//       {openModal && (
//         <ImageModal
//           open={openModal}
//           handleClose={handleCloseModal}
//           imageUrl={selectedImage}
//         />
//       )}
//     </LayoutContainer>
//   );
// };

// export default StaionReport;

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Modal,
  TableContainer,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminHeader from '../../components/AdminHeader';
import LayoutContainer from '../../components/LayoutContainer';
import itemDeliveryService from '../../services/itemDeliveryService';
import {
  filter,
  flatMap,
  get,
  groupBy,
  isArray,
  map,
  mapValues,
  partition,
  pickBy,
  startsWith,
  uniq,
} from 'lodash';
import * as XLSX from 'xlsx';
import { ImageModal } from '../supervisor/SupervisorForm';
import moment from 'moment';
import { FaLocationArrow } from 'react-icons/fa6';

const StaionReport = () => {
  const [itemDeliveries, setItemDeliveries] = useState([]);
  const [showDeliveryModal, setShowDeliveryModal] = useState(false);
  const [deliveryId, setDeliveryId] = useState(false);
  const [selectedStation, setSelectedStation] = useState('');
  const [selectedStationType, setSelectedStationType] = useState('ROUTE');
  const [selectedProduct, setSelectedProduct] = useState('');
  const [filteredDeliveries, setFilteredDeliveries] = useState([]);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [rowStation, setRowStation] = useState('');
  const [productList, setProductList] = useState([]);

  console.log('productList', productList, itemDeliveries);

  // Fetch item deliveries
  const fetchItemDeliveries = async () => {
    const response = await itemDeliveryService.deliveryReport();
    const groupedDeliveries = groupBy(
      filter(response?.data, {
        event_id: parseInt(localStorage?.getItem('event_id')),
      }),
      'station'
    );
    setItemDeliveries(groupedDeliveries);
    setFilteredDeliveries(
      pickBy(
        mapValues(groupedDeliveries, (routeItems) =>
          filter(
            filter(routeItems, {
              event_id: parseInt(localStorage?.getItem('event_id')),
            }),
            {
              station_type: 'ROUTE',
            }
          )
        ),
        (stationItems) => stationItems.length > 0
      )
    );
  };

  const allProducts = [
    ...new Set(
      Object.values(itemDeliveries).flatMap((items) =>
        items.map((item) => item.item_name)
      )
    ),
  ];

  useEffect(() => {
    fetchItemDeliveries();
  }, []);

  useEffect(() => {
    if (filteredDeliveries && selectedStation) {
      setProductList(
        uniq(
          map(
            filteredDeliveries[selectedStation],
            (stationItems) => stationItems?.item_name
          )
        )
      );
    } else if (selectedStationType) {
      const stationTypeProduct = [
        ...new Set(
          Object.values(
            mapValues(itemDeliveries, (routeItems) =>
              filter(routeItems, {
                station_type: selectedStationType,
              })
            )
          ).flatMap((items) => items.map((item) => item.item_name))
        ),
      ];
      setProductList(stationTypeProduct);
    } else {
      setProductList(allProducts);
    }
  }, [
    itemDeliveries,
    filteredDeliveries,
    selectedStation,
    selectedStationType,
  ]);

  console.log(
    'filteredDeliveries[selectedStation]',
    itemDeliveries,
    filteredDeliveries,
    selectedStation,
    filteredDeliveries[selectedStation],
    selectedStationType,
    allProducts
  );

  // Handle station filter change
  const handleStationChange = (event) => {
    const station =
      event.target.value === 'ALL STATIONS' ? '' : event.target.value;
    setSelectedStation(station);

    // Filter deliveries based on both station and product (if selected)
    filterDeliveries(station, selectedProduct);
  };

  // Handle product filter change
  const handleProductChange = (event) => {
    const product =
      event.target.value === 'ALL PRODUCTS' ? '' : event.target.value;
    setSelectedProduct(product);

    // Filter deliveries based on both product and station (if selected)
    filterDeliveries(selectedStation, product);
  };

  // Filter deliveries based on station and product
  const filterDeliveries = (station, product, stationType) => {
    let filtered = itemDeliveries;

    // Filter by station if selected
    if (station) {
      filtered = { [station]: itemDeliveries[station] };
    }

    // Further filter by product if selected
    if (product) {
      filtered = Object.fromEntries(
        Object.entries(filtered).map(([station, items]) => [
          station,
          items.filter((item) => item.item_name === product),
        ])
      );
    }

    if (stationType) {
      filtered = Object.fromEntries(
        Object.entries(filtered).map(([station, items]) => [
          station,
          items.filter((item) => item.station_type === stationType),
        ])
      );
    }

    setFilteredDeliveries(
      pickBy(filtered, (stationItems) => stationItems.length > 0)
    );
  };

  console.log('filteredDeliveries', filteredDeliveries);

  const handleStationTypeChange = (event) => {
    const stationType =
      event.target.value === 'ALL STATION TYPES' ? '' : event.target.value;
    setSelectedStationType(stationType);

    setSelectedStation('');
    setSelectedProduct('');
    // Filter deliveries based on both station type and product (if selected)
    filterDeliveries('', '', stationType);
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedImage(null);
  };

  const handleCloseTable = () => {
    setShowDeliveryModal(false);
    setDeliveryId(null);
  };

  console.log('allProductsallProducts', filteredDeliveries);

  const tableRef = useRef(null); // Create a ref for the table

  const downloadExcel = () => {
    // Prepare the data array (with headers)
    const headers = [
      'STATION NAME',
      'PRODUCT',
      'STATION TYPE',
      'ALLOCATED QTY',
      'DELIVERED QTY',
      'PICKED QTY',
      'STATUS',
    ];

    // Prepare data from filtered deliveries
    const rows = [];
    Object.entries(filteredDeliveries).forEach(([station, items]) => {
      items.forEach((item) => {
        const allocatedQty = parseInt(item?.allocated_qty, 10) || 0;
        const deliveredQty = parseInt(item?.delivered_qty, 10) || 0;
        const pickedQty = parseInt(item?.picked_qty, 10) || 0;

        // Define the status logic
        let status;
        if (allocatedQty < deliveredQty) {
          status = pickedQty ? 'Exceeded & Pickup' : 'Exceeded';
        } else if (allocatedQty > 0 && allocatedQty === deliveredQty) {
          status = pickedQty ? 'Delivered & Pickup' : 'Delivered';
        } else if (allocatedQty > deliveredQty && deliveredQty !== 0) {
          status = pickedQty
            ? 'Partially Delivered & Pickup'
            : 'Partially Delivered';
        } else {
          status = 'Not Delivered';
        }

        // Push each row of data (excluding unnecessary columns like Action and Photos)
        rows.push([
          item?.station,
          item?.item_name,
          item?.station_type,
          allocatedQty,
          deliveredQty,
          pickedQty,
          status,
        ]);
      });
    });

    // Combine the headers with the rows data
    const data = [headers, ...rows];

    // Create a worksheet from the data
    const ws = XLSX.utils.aoa_to_sheet(data);

    // Create a new workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Write the Excel file and trigger the download
    XLSX.writeFile(wb, 'delivery_report.xlsx');
  };

  return (
    // <LayoutContainer>
    //   <AdminHeader title='DELIVERY REPORT' />
    //   <div style={{ padding: '1rem 3rem' }}>
    //     {/* Station Filter Dropdown */}
    //     <FormControl
    //       style={{
    //         width: '200px',
    //         marginRight: '0.8rem',
    //       }}
    //     >
    //       <Select
    //         value={selectedStation || 'ALL STATIONS'}
    //         onChange={handleStationChange}
    //       >
    //         <MenuItem value='ALL STATIONS'>ALL STATIONS</MenuItem>
    //         {Object.keys(itemDeliveries).map((station) => (
    //           <MenuItem key={station} value={station}>
    //             {station}
    //           </MenuItem>
    //         ))}
    //       </Select>
    //     </FormControl>

    //     {/* Product Filter Dropdown */}
    //     <FormControl style={{ width: '200px' }}>
    //       <Select
    //         value={selectedProduct || 'ALL PRODUCTS'}
    //         onChange={handleProductChange}
    //       >
    //         <MenuItem value='ALL PRODUCTS'>ALL PRODUCTS</MenuItem>
    //         {allProducts.map((product) => (
    //           <MenuItem key={product} value={product}>
    //             {product}
    //           </MenuItem>
    //         ))}
    //       </Select>
    //     </FormControl>

    //     {/* Table to display filtered deliveries */}
    //     <Table
    //       style={{
    //         width: '100%',
    //         borderCollapse: 'collapse',
    //         fontFamily: 'Arial, sans-serif',
    //         marginTop: '20px',
    //       }}
    //     >
    //       {/* Table Header */}
    //       <TableHead
    //         style={{
    //           backgroundColor: '#2F3542',
    //           fontWeight: 'bold',
    //           position: 'sticky',
    //           top: 0,
    //           zIndex: 1,
    //         }}
    //       >
    //         <TableRow>
    //           <TableCell
    //             style={{
    //               padding: '12px 15px',
    //               color: '#fff',
    //               textAlign: 'left',
    //               fontWeight: '550 !important',
    //               fontSize: '0.8rem !important',
    //             }}
    //           >
    //             PRODUCT
    //           </TableCell>
    //           <TableCell
    //             style={{
    //               padding: '12px 15px',
    //               textAlign: 'left',
    //               border: '1px solid #ddd',
    //               fontWeight: '550 !important',
    //               fontSize: '0.8rem !important',
    //               color: '#fff',
    //             }}
    //           >
    //             ALLOCATED QTY
    //           </TableCell>
    //           <TableCell
    //             style={{
    //               padding: '12px 15px',
    //               textAlign: 'left',
    //               border: '1px solid #ddd',
    //               fontWeight: '550 !important',
    //               fontSize: '0.8rem !important',
    //               color: '#fff',
    //             }}
    //           >
    //             DELIVERED QTY
    //           </TableCell>
    //           <TableCell
    //             style={{
    //               padding: '12px 15px',
    //               textAlign: 'left',
    //               border: '1px solid #ddd',
    //               fontWeight: '550 !important',
    //               fontSize: '0.8rem !important',
    //               color: '#fff',
    //             }}
    //           >
    //             PICKED QTY
    //           </TableCell>
    //           <TableCell
    //             style={{
    //               padding: '12px 15px',
    //               textAlign: 'left',
    //               border: '1px solid #ddd',
    //               fontWeight: '550 !important',
    //               fontSize: '0.8rem !important',
    //               color: '#fff',
    //             }}
    //           >
    //             STATUS
    //           </TableCell>
    //           <TableCell
    //             style={{
    //               padding: '12px 15px',
    //               textAlign: 'left',
    //               border: '1px solid #ddd',
    //               fontWeight: '550 !important',
    //               fontSize: '0.8rem !important',
    //               color: '#fff',
    //             }}
    //           >
    //             DELIVERY PHOTO
    //           </TableCell>
    //           <TableCell
    //             style={{
    //               padding: '12px 15px',
    //               textAlign: 'left',
    //               fontWeight: '550 !important',
    //               fontSize: '0.8rem !important',
    //               color: '#fff',
    //             }}
    //           >
    //             PICKUP PHOTO
    //           </TableCell>
    //         </TableRow>
    //       </TableHead>

    //       {/* Table Body with scrollable content */}
    //       <TableBody
    //         style={{
    //           display: 'block',
    //           maxHeight: '400px', // Set a max height for the table body
    //           overflowY: 'auto', // Enable vertical scrolling
    //         }}
    //       >
    //         {Object.entries(filteredDeliveries)?.map(([station, items]) => (
    //           <>
    //             <TableRow
    //               key={station}
    //               style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}
    //             >
    //               <TableCell
    //                 colSpan={7}
    //                 style={{
    //                   textAlign: 'left',
    //                   padding: '12px 15px',
    //                   border: '1px solid #ddd',
    //                   fontWeight: 600,
    //                 }}
    //               >
    //                 {station}
    //               </TableCell>
    //             </TableRow>
    //             {items.map((item) => {
    //               const [deliveredPhoto, pickupPhoto] = item?.photo
    //                 ? partition(item?.photo.split(', '), (item) =>
    //                     item.startsWith('Delivered_photo')
    //                   )
    //                 : '';

    //               const allocatedQty = parseInt(get(item, 'allocated_qty', 0));
    //               const deliveredQty = parseInt(get(item, 'delivered_qty', 0));
    //               const pickedQty = parseInt(get(item, 'picked_qty', 0));
    //               let status;

    //               if (allocatedQty < deliveredQty) {
    //                 status = pickedQty ? 'Exceeded & Pickup' : 'Exceeded';
    //               } else if (
    //                 allocatedQty > 0 &&
    //                 allocatedQty === deliveredQty
    //               ) {
    //                 status = pickedQty ? 'Delivered & Pickup' : 'Delivered';
    //               } else if (
    //                 allocatedQty > deliveredQty &&
    //                 deliveredQty !== 0
    //               ) {
    //                 status = pickedQty
    //                   ? 'Partially Delivered & Pickup'
    //                   : 'Partially Delivered';
    //               } else {
    //                 status = 'Not Delivered';
    //               }

    //               return (
    //                 <TableRow
    //                   key={item?.id}
    //                   style={{
    //                     transition: 'background-color 0.3s',
    //                     cursor: 'pointer',
    //                   }}
    //                   onMouseOver={(e) =>
    //                     (e.currentTarget.style.backgroundColor = '#f2f2f2')
    //                   }
    //                   onMouseOut={(e) =>
    //                     (e.currentTarget.style.backgroundColor = '')
    //                   }
    //                 >
    //                   <TableCell
    //                     style={{
    //                       padding: '12px 15px',
    //                       textAlign: 'left',
    //                       border: '1px solid #ddd',
    //                     }}
    //                   >
    //                     {item?.item_name}
    //                   </TableCell>
    //                   <TableCell
    //                     style={{
    //                       padding: '12px 15px',
    //                       textAlign: 'right',
    //                       border: '1px solid #ddd',
    //                     }}
    //                   >
    //                     {item?.allocated_qty}
    //                   </TableCell>
    //                   <TableCell
    //                     style={{
    //                       padding: '12px 15px',
    //                       border: '1px solid #ddd',
    //                       textAlign: 'right',
    //                     }}
    //                   >
    //                     {item?.delivered_qty}
    //                   </TableCell>
    //                   <TableCell
    //                     style={{
    //                       padding: '12px 15px',
    //                       border: '1px solid #ddd',
    //                       textAlign: 'right',
    //                     }}
    //                   >
    //                     {item?.picked_qty}
    //                   </TableCell>
    //                   <TableCell
    //                     style={{
    //                       padding: '12px 15px',
    //                       textAlign: 'left',
    //                       border: '1px solid #ddd',
    //                       color: 'white',
    //                       backgroundColor:
    //                         status === 'Delivered'
    //                           ? '#15be15'
    //                           : status === 'Delivered & Pickup'
    //                           ? '#15be15'
    //                           : status === 'Exceeded & Pickup'
    //                           ? '#ff0101'
    //                           : status === 'Exceeded'
    //                           ? '#ff0101'
    //                           : status === 'Partially Delivered'
    //                           ? '#1C90FF'
    //                           : status === 'Partially Delivered & Pickup'
    //                           ? '#1C90FF'
    //                           : status === 'Not Delivered'
    //                           ? 'orange'
    //                           : '#05c6ec',
    //                     }}
    //                   >
    //                     {status?.toUpperCase()}
    //                   </TableCell>
    //                   <TableCell
    //                     style={{
    //                       padding: '12px 15px',
    //                       textAlign: 'center',
    //                       border: '1px solid #ddd',
    //                     }}
    //                   >
    //                     {isArray(deliveredPhoto) &&
    //                     deliveredPhoto.length > 0 ? (
    //                       <div
    //                         style={{
    //                           display: 'flex',
    //                           flexWrap: 'wrap', // Enable wrapping of images
    //                           justifyContent: 'center', // Align images in the center
    //                           gap: '5px', // Add gap between images
    //                         }}
    //                       >
    //                         {map(deliveredPhoto, (photo, index) => {
    //                           // Dynamically adjust size based on number of images
    //                           const size = deliveredPhoto.length > 5 ? 25 : 30; // Reduce size if more than 5 images
    //                           return (
    //                             <img
    //                               key={index}
    //                               src={`${process.env.REACT_APP_IMAGE_URL}/images/${photo}`}
    //                               height={size}
    //                               width={size}
    //                               style={{
    //                                 borderRadius: '10%',
    //                                 border: '2px solid #ddd',
    //                                 padding: '2px',
    //                                 cursor: 'pointer', // Make it look clickable
    //                               }}
    //                               alt='Item'
    //                               onClick={() => {
    //                                 setOpenModal(true);
    //                                 setSelectedImage(photo);
    //                               }} // Open modal with clicked image
    //                             />
    //                           );
    //                         })}
    //                       </div>
    //                     ) : (
    //                       '-'
    //                     )}
    //                   </TableCell>
    //                   <TableCell
    //                     style={{
    //                       padding: '12px 15px',
    //                       textAlign: 'center',
    //                       border: '1px solid #ddd',
    //                     }}
    //                   >
    //                     {isArray(pickupPhoto) && pickupPhoto.length > 0 ? (
    //                       <div
    //                         style={{
    //                           display: 'flex',
    //                           flexWrap: 'wrap', // Enable wrapping of images
    //                           justifyContent: 'center', // Align images in the center
    //                           gap: '5px', // Add gap between images
    //                         }}
    //                       >
    //                         {map(pickupPhoto, (photo, index) => {
    //                           // Dynamically adjust size based on number of images
    //                           const size = pickupPhoto.length > 5 ? 25 : 30; // Reduce size if more than 5 images
    //                           return (
    //                             <img
    //                               key={index}
    //                               src={`${process.env.REACT_APP_IMAGE_URL}/images/${photo}`}
    //                               height={size}
    //                               width={size}
    //                               style={{
    //                                 borderRadius: '10%',
    //                                 border: '2px solid #ddd',
    //                                 padding: '2px',
    //                                 cursor: 'pointer', // Make it look clickable
    //                               }}
    //                               alt='Item'
    //                               onClick={() => {
    //                                 setOpenModal(true);
    //                                 setSelectedImage(photo);
    //                               }} // Open modal with clicked image
    //                             />
    //                           );
    //                         })}
    //                       </div>
    //                     ) : (
    //                       '-'
    //                     )}
    //                   </TableCell>
    //                 </TableRow>
    //               );
    //             })}
    //           </>
    //         ))}
    //       </TableBody>
    //     </Table>
    //   </div>

    //   {/* Modal for image */}
    //   {openModal && (
    //     <ImageModal
    //       open={openModal}
    //       handleClose={handleCloseModal}
    //       imageUrl={selectedImage}
    //     />
    //   )}
    // </LayoutContainer>

    <LayoutContainer>
      <AdminHeader title='DELIVERY REPORT' />
      <div style={{ padding: '1rem 3rem' }}>
        {/* Station Filter Dropdown */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <FormControl style={{ width: '230px' }}>
              <Select
                value={selectedStationType || 'ROUTE'}
                onChange={handleStationTypeChange}
                sx={{ fontSize: '0.675rem' }}
              >
                <MenuItem
                  value='ALL STATION TYPES'
                  sx={{ display: 'none', fontSize: '0.675rem' }}
                >
                  ROUTE
                </MenuItem>
                {['ROUTE', 'JUNCTION'].map((type) => (
                  <MenuItem
                    key={type}
                    value={type}
                    sx={{ fontSize: '0.675rem' }}
                  >
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl style={{ width: '230px' }}>
              <Select
                value={selectedStation || 'ALL STATIONS'}
                onChange={handleStationChange}
                sx={{ fontSize: '0.675rem' }}
              >
                <MenuItem value='ALL STATIONS' sx={{ fontSize: '0.675rem' }}>
                  ALL STATIONS
                </MenuItem>
                {Object.keys(
                  groupBy(
                    flatMap(itemDeliveries, (items) =>
                      filter(items, {
                        station_type: selectedStationType,
                      })
                    ),
                    'station'
                  )
                ).map((station) => (
                  <MenuItem
                    key={station}
                    value={station}
                    sx={{ fontSize: '0.675rem' }}
                  >
                    {station}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Product Filter Dropdown */}
            <FormControl style={{ width: '230px' }}>
              <Select
                value={selectedProduct || 'ALL PRODUCTS'}
                onChange={handleProductChange}
                sx={{ fontSize: '0.675rem' }}
              >
                <MenuItem value='ALL PRODUCTS' sx={{ fontSize: '0.675rem' }}>
                  ALL PRODUCTS
                </MenuItem>
                {productList.map((product) => (
                  <MenuItem
                    key={product}
                    value={product}
                    sx={{ fontSize: '0.675rem' }}
                  >
                    {product}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          {/* <Box>
            <Button
              variant='contained'
              onClick={() => setShowDeliveryModal(true)}
            >
              Delivery Logs
            </Button>
          </Box> */}

          <Button
            variant='contained'
            onClick={downloadExcel}
            sx={{ fontSize: '0.675rem' }}
          >
            Download Excel
          </Button>
        </Box>
        {/* Table Container */}
        <div
          style={{
            marginTop: '20px',
            height: 'calc(100vh - 6rem)',
            overflowY: 'auto',
            borderRadius: '5px',
          }}
        >
          <Table
            ref={tableRef}
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              fontFamily: 'Arial, sans-serif',
              marginBottom: '5rem',
            }}
          >
            <TableHead
              style={{
                backgroundColor: '#2F3542',
                fontWeight: 'bold',
                position: 'sticky',
                top: 0,
                zIndex: 1,
              }}
            >
              <TableRow>
                <TableCell
                  style={{
                    padding: '12px 15px',
                    color: '#fff',
                    textAlign: 'left',
                    fontWeight: '550 !important',
                    fontSize: '0.675rem ',
                  }}
                >
                  PRODUCT
                </TableCell>
                <TableCell
                  style={{
                    padding: '12px 15px',
                    color: '#fff',
                    textAlign: 'left',
                    fontWeight: '550 !important',
                    fontSize: '0.675rem',
                    border: '1px solid #ddd',
                  }}
                >
                  STATION TYPE
                </TableCell>
                <TableCell
                  style={{
                    padding: '12px 15px',
                    textAlign: 'left',
                    border: '1px solid #ddd',
                    fontWeight: '550 !important',
                    fontSize: '0.675rem',
                    color: '#fff',
                  }}
                >
                  ALLOCATED QTY
                </TableCell>
                <TableCell
                  style={{
                    padding: '12px 15px',
                    textAlign: 'left',
                    border: '1px solid #ddd',
                    fontWeight: '550 !important',
                    fontSize: '0.675rem',
                    color: '#fff',
                  }}
                >
                  DELIVERED QTY
                </TableCell>
                <TableCell
                  style={{
                    padding: '12px 15px',
                    textAlign: 'left',
                    border: '1px solid #ddd',
                    fontWeight: '550 !important',
                    fontSize: '0.675rem',
                    color: '#fff',
                  }}
                >
                  PICKED QTY
                </TableCell>
                <TableCell
                  style={{
                    padding: '12px 15px',
                    textAlign: 'left',
                    border: '1px solid #ddd',
                    fontWeight: '550 !important',
                    fontSize: '0.675rem',
                    color: '#fff',
                  }}
                >
                  LOCATION
                </TableCell>
                <TableCell
                  style={{
                    padding: '12px 15px',
                    textAlign: 'left',
                    border: '1px solid #ddd',
                    fontWeight: '550 !important',
                    fontSize: '0.675rem',
                    color: '#fff',
                  }}
                >
                  STATUS
                </TableCell>
                <TableCell
                  style={{
                    padding: '12px 15px',
                    textAlign: 'left',
                    border: '1px solid #ddd',
                    fontWeight: '550 !important',
                    fontSize: '0.675rem',
                    color: '#fff',
                  }}
                >
                  DELIVERY PHOTO
                </TableCell>
                <TableCell
                  style={{
                    padding: '12px 15px',
                    textAlign: 'left',
                    border: '1px solid #ddd',
                    fontWeight: '550 !important',
                    fontSize: '0.675rem',
                    color: '#fff',
                  }}
                >
                  PICKUP PHOTO
                </TableCell>

                <TableCell
                  style={{
                    padding: '12px 15px',
                    textAlign: 'left',
                    fontWeight: '550 !important',
                    fontSize: '0.675rem',
                    color: '#fff',
                  }}
                >
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {Object.entries(filteredDeliveries)?.map(([station, items]) => (
                <>
                  <TableRow
                    key={station}
                    style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}
                  >
                    <TableCell
                      colSpan={10}
                      style={{
                        textAlign: 'left',
                        padding: '12px 15px',
                        border: '1px solid #ddd',
                        fontWeight: 600,
                        fontSize: '0.675rem',
                      }}
                    >
                      {station}
                    </TableCell>
                  </TableRow>
                  {items.map((item) => {
                    const [deliveredPhoto, pickupPhoto] = item?.photo
                      ? partition(item?.photo.split(', '), (item) =>
                          item.startsWith('Delivered_photo')
                        )
                      : '';

                    const allocatedQty = parseInt(
                      get(item, 'allocated_qty', 0)
                    );
                    const deliveredQty = parseInt(
                      get(item, 'delivered_qty', 0)
                    );
                    const pickedQty = parseInt(get(item, 'picked_qty', 0));
                    let status;

                    if (allocatedQty < deliveredQty) {
                      status = pickedQty ? 'Exceeded & Pickup' : 'Exceeded';
                    } else if (
                      allocatedQty > 0 &&
                      allocatedQty === deliveredQty
                    ) {
                      status = pickedQty ? 'Delivered & Pickup' : 'Delivered';
                    } else if (
                      allocatedQty > deliveredQty &&
                      deliveredQty !== 0
                    ) {
                      status = pickedQty
                        ? 'Partially Delivered & Pickup'
                        : 'Partially Delivered';
                    } else {
                      status = 'Not Delivered';
                    }

                    return (
                      <TableRow key={item?.id}>
                        <TableCell
                          style={{
                            padding: '12px 15px',
                            textAlign: 'left',
                            border: '1px solid #ddd',
                            fontSize: '0.675rem',
                          }}
                        >
                          {item?.item_name}
                        </TableCell>
                        <TableCell
                          style={{
                            padding: '12px 15px',
                            textAlign: 'left',
                            border: '1px solid #ddd',
                            fontSize: '0.675rem',
                          }}
                        >
                          {item?.station_type}
                        </TableCell>
                        <TableCell
                          style={{
                            padding: '12px 15px',
                            textAlign: 'right',
                            border: '1px solid #ddd',
                            fontSize: '0.675rem',
                          }}
                        >
                          {item?.allocated_qty}
                        </TableCell>
                        <TableCell
                          style={{
                            padding: '12px 15px',
                            border: '1px solid #ddd',
                            textAlign: 'right',
                            fontSize: '0.675rem',
                          }}
                        >
                          {item?.delivered_qty}
                        </TableCell>
                        <TableCell
                          style={{
                            padding: '12px 15px',
                            border: '1px solid #ddd',
                            textAlign: 'right',
                            fontSize: '0.675rem',
                          }}
                        >
                          {item?.picked_qty}
                        </TableCell>
                        <TableCell
                          style={{
                            padding: '12px 15px',
                            textAlign: 'center',
                            border: '1px solid #ddd',
                            fontSize: '0.675rem',
                          }}
                        >
                          {item?.latitude && item?.longitude ? (
                            <button
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: '#007bff', // Customize background color as needed
                                color: 'white',
                                border: 'none',
                                padding: '5px 10px',
                                cursor: 'pointer',
                                borderRadius: '5px',
                                fontSize: '0.675rem',
                              }}
                              onClick={() =>
                                window.open(
                                  `https://www.google.com/maps?q=${item?.latitude},${item?.longitude}`,
                                  '_blank'
                                )
                              }
                            >
                              <FaLocationArrow
                                size={14}
                                color='white'
                                style={{ marginRight: '8px' }}
                              />
                              LOCATION
                            </button>
                          ) : (
                            '-'
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            padding: '12px 15px',
                            textAlign: 'left',
                            border: '1px solid #ddd',
                            fontSize: '0.675rem',
                            color: 'white',
                            backgroundColor:
                              status === 'Delivered'
                                ? '#15be15'
                                : status === 'Delivered & Pickup'
                                ? '#15be15'
                                : status === 'Exceeded & Pickup'
                                ? '#ff0101'
                                : status === 'Exceeded'
                                ? '#ff0101'
                                : status === 'Partially Delivered'
                                ? '#1C90FF'
                                : status === 'Partially Delivered & Pickup'
                                ? '#1C90FF'
                                : status === 'Not Delivered'
                                ? 'orange'
                                : '#05c6ec',
                          }}
                        >
                          {status?.toUpperCase()}
                        </TableCell>
                        <TableCell
                          style={{
                            padding: '12px 15px',
                            textAlign: 'center',
                            border: '1px solid #ddd',
                            fontSize: '0.675rem',
                          }}
                        >
                          {isArray(deliveredPhoto) &&
                          deliveredPhoto.length > 0 ? (
                            <div
                              style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'center',
                                gap: '5px',
                              }}
                            >
                              {map(deliveredPhoto, (photo, index) => {
                                const size =
                                  deliveredPhoto.length > 5 ? 25 : 30;
                                return photo ? (
                                  <img
                                    key={index}
                                    src={`${process.env.REACT_APP_IMAGE_URL}/images/${photo}`}
                                    height={size}
                                    width={size}
                                    style={{
                                      borderRadius: '10%',
                                      border: '2px solid #ddd',
                                      padding: '2px',
                                      cursor: 'pointer',
                                    }}
                                    alt='Item'
                                    onClick={() => {
                                      setOpenModal(true);
                                      setSelectedImage(photo);
                                    }}
                                  />
                                ) : (
                                  ''
                                );
                              })}
                            </div>
                          ) : (
                            '-'
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            padding: '12px 15px',
                            textAlign: 'center',
                            border: '1px solid #ddd',
                            fontSize: '0.675rem',
                          }}
                        >
                          {isArray(pickupPhoto) && pickupPhoto.length > 0 ? (
                            <div
                              style={{
                                display: 'flex',
                                flexWrap: 'wrap', // Enable wrapping of images
                                justifyContent: 'center', // Align images in the center
                                gap: '5px', // Add gap between images
                              }}
                            >
                              {map(pickupPhoto, (photo, index) => {
                                // Dynamically adjust size based on number of images
                                const size = pickupPhoto.length > 5 ? 25 : 30; // Reduce size if more than 5 images
                                return photo ? (
                                  <img
                                    key={index}
                                    src={`${process.env.REACT_APP_IMAGE_URL}/images/${photo}`}
                                    height={size}
                                    width={size}
                                    style={{
                                      borderRadius: '10%',
                                      border: '2px solid #ddd',
                                      padding: '2px',
                                      cursor: 'pointer', // Make it look clickable
                                    }}
                                    alt='Item'
                                    onClick={() => {
                                      setOpenModal(true);
                                      setSelectedImage(photo);
                                    }}
                                  />
                                ) : (
                                  ''
                                );
                              })}
                            </div>
                          ) : (
                            '-'
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            padding: '12px 15px',
                            textAlign: 'center',
                            border: '1px solid #ddd',
                          }}
                        >
                          <Button
                            variant='contained'
                            sx={{
                              textTransform: 'none',
                              fontSize: '0.675rem',
                            }}
                            onClick={() => {
                              setShowDeliveryModal(true);
                              setDeliveryId(item?.id);
                              setRowStation(station);
                            }}
                          >
                            DETAILS
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
      {openModal && (
        <ImageModal
          open={openModal}
          handleClose={handleCloseModal}
          imageUrl={selectedImage}
        />
      )}
      {showDeliveryModal && (
        <DataTable
          open={showDeliveryModal}
          handleClose={handleCloseTable}
          deliveryId={deliveryId}
          rowStation={rowStation}
        />
      )}
    </LayoutContainer>
  );
};

export default StaionReport;

export const DataTable = ({ open, handleClose, deliveryId, rowStation }) => {
  const [itemDeliveryLogs, setItemDeliveryLogs] = useState([]);

  console.log('rowStation', rowStation);

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: 'calc(100vh - 6rem)', // Adjust height based on your requirements
    width: 800,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between', // Space between the table and button
  };

  const tableContainerStyle = {
    flexGrow: 1, // Make sure the table content grows and fills available space
    overflowY: 'auto', // Enable vertical scrolling
    marginBottom: '1rem', // Ensure space for the button
  };

  const fixedHeaderStyle = {
    position: 'sticky',
    top: 0,
    background: 'white', // Prevent header from blending with table body
    zIndex: 1, // Keep the header above the scrollable body
    fontSize: '0.675rem',
    fontWeight: 550,
    borderLeft: '1px solid #e0e0e0',
    borderRight: '1px solid #e0e0e0',
    borderTop: '1px solid #e0e0e0',
  };

  const smallCellStyle = {
    fontSize: '0.675rem',
    borderLeft: '1px solid #e0e0e0',
    borderRight: '1px solid #e0e0e0',
  };

  const getDeliveryLog = async () => {
    const response = await itemDeliveryService.itemDeliveryLogs(deliveryId);
    setItemDeliveryLogs(
      filter(response?.data, (data) => data?.station === rowStation)
    );
  };

  useEffect(() => {
    if (deliveryId) {
      getDeliveryLog();
    }
  }, [deliveryId]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <h5>DETAILS</h5>
        <TableContainer sx={tableContainerStyle}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={fixedHeaderStyle}>STATION</TableCell>
                <TableCell sx={fixedHeaderStyle}>PRODUCT</TableCell>
                <TableCell sx={fixedHeaderStyle}>STATION TYPE</TableCell>
                <TableCell sx={fixedHeaderStyle}>ALLOCATED QTY</TableCell>
                <TableCell sx={fixedHeaderStyle}>DELIVERED QTY</TableCell>
                <TableCell sx={fixedHeaderStyle}>PICKED QTY</TableCell>
                <TableCell sx={fixedHeaderStyle}>ITEM TYPE</TableCell>
                <TableCell sx={fixedHeaderStyle}>DELIVERED DATE</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {itemDeliveryLogs?.map((row) => (
                <TableRow key={row.id}>
                  <TableCell sx={smallCellStyle}>{row.station}</TableCell>
                  <TableCell sx={smallCellStyle}>{row.item_name}</TableCell>
                  <TableCell sx={smallCellStyle}>{row.station_type}</TableCell>
                  <TableCell sx={smallCellStyle}>{row.allocated_qty}</TableCell>
                  <TableCell sx={smallCellStyle}>{row.delivered_qty}</TableCell>
                  <TableCell sx={smallCellStyle}>{row.picked_qty}</TableCell>
                  <TableCell sx={smallCellStyle}>
                    {row.remarks?.toUpperCase()}
                  </TableCell>
                  <TableCell sx={smallCellStyle}>
                    {row.delivered_date
                      ? moment(row?.delivered_date).format('DD/MM/YYYY HH:mm')
                      : '-'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {/* Adjust the button positioning to be at the bottom of the modal */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={handleClose}
            sx={{
              fontSize: '0.675rem',
              alignSelf: 'center', // Center the button horizontally
              marginTop: '1rem', // Ensure a margin between the table and button
            }}
            variant='contained'
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
